module.exports = __webpack_public_path__ + "img/expired_timer.c258b1ca.svg";